import styled from "styled-components";

import {
    subMenuDropdownBackground
} from '../../config/colors';

export const ProjcetNotesWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    background-color: ${subMenuDropdownBackground};
    padding: 40px 25px 95px 42px;

    @media print {
      background-color: inherit;
    }
`;

export const NotesList = styled.ul`
    list-style: "*";
    margin: 0;
    padding: 0;
`;

export const NoteItem = styled.li`
    line-height: 2;
    padding-left: 8px;
    font-size: 0.875rem;

    ::marker{
        font-weight: bold;
    }
`;